import styled from 'styled-components'

const TokenExpanderWrapper = styled.div`
  width: 100%;
`

export { TokenExpanderWrapper }
